module.exports = __webpack_public_path__ + "static/3-5821ef21157b2774d81705bd3ae22a07.png";